import { Download1Stroke, EyeStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_danh_muc_ban_hang_han_thanh_toan_DMHTT } from '@/lib/templates-base64/DMHTT';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: () => void;
  onWatchIconClick: () => void;
  onImportFromExcel?: () => void;
}

const handleDownloadExcelTemplate = () => {
  downloadBase64Excel(excelTemplate_danh_muc_ban_hang_han_thanh_toan_DMHTT, 'Danh mục hạn thanh toán.xlsx');
};

const ActionBar = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onImportFromExcel
}: ActionBarProps) => (
  <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục hạn thanh toán</h1>}>
    <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} variant='primary' />
    <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} />
    <ActionButtonV2 icon={Trash3Stroke} title='Xoá' variant='destructive' onClick={onDeleteIconClick} />
    <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyIconClick} />
    <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} />
    <MenuButtonV2
      items={[
        {
          title: 'Refresh',
          icon: <AritoIcon icon={15} />,
          onClick: () => window.location.reload(),
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: <AritoIcon icon={16} />,
          onClick: () => {},
          group: 0
        },
        {
          title: 'Tải mẫu Excel',
          icon: <AritoIcon icon={28} />,
          onClick: handleDownloadExcelTemplate,
          group: 1
        },
        {
          title: 'Lấy dữ liệu từ excel',
          icon: <AritoIcon icon={29} />,
          onClick: () => onImportFromExcel?.(),
          group: 1
        },

        {
          title: 'Kết xuất dữ liệu',
          icon: <AritoIcon icon={555} />,
          onClick: () => {},
          group: 2
        }
      ]}
    />
  </ActionBarV2>
);

export default ActionBar;
